'use client'

import LoadingSpinner from "@/components/common/LoadingSpinner";

const Loading = () => {
  return <LoadingSpinner isLoading={true} />;
}

export default Loading;